import { render, staticRenderFns } from "./biscuitdetail.vue?vue&type=template&id=585c525e&"
import script from "./biscuitdetail.vue?vue&type=script&lang=js&"
export * from "./biscuitdetail.vue?vue&type=script&lang=js&"
import style0 from "./biscuitdetail.vue?vue&type=style&index=0&id=585c525e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports